$(function() {
    "use strict";

    $(document).on('ready', function () {

        var jcropApi;
        var $loader = $('.image-crop-loader');

        if (!$loader.length) {
            return;
        }

        var modalId = 'modal_image-loader-crop';
        var $modal = $('#' + modalId);
        var $modalImage = $modal.find('.modall__image');
        var $preview = $modal.find('.modall__image-preview__src');
        var imageWidth = 0;
        var imageHeight = 0;

        $loader.on('click', function(event) {

            event.preventDefault();
            var $img = $(this).clone();
            window.Modal.openModal(modalId);

            $modalImage.append($img);
            $preview.attr('src', $img.attr('src'));
            $img.on('load', function() {
                $img.Jcrop({
                    aspectRatio: 1,
                    bgColor:     'black',
                    bgOpacity:   .4,
                    minSize: [100, 100],
                    setSelect: [0, 0, 100, 100],
                    onChange: showPreview,
                    onSelect: showPreview,
                    onRelease: release
                }, function () {
                    jcropApi = this;
                });

                imageWidth = $modalImage.find('.jcrop-holder img').width();
                imageHeight = $modalImage.find('.jcrop-holder img').height();

                jcropApi.setSelect([0, 0, 100, 100]);
            });
        });

        var showPreview = function(coords) {
            var rx = 100 / coords.w;
            var ry = 100 / coords.h;
            $preview.css({
                width: Math.round(rx * imageWidth) + 'px',
                height: Math.round(ry * imageHeight) + 'px',
                marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                marginTop: '-' + Math.round(ry * coords.y) + 'px'
            }).show();
        };

        var release = function() {
            var newWidth = 100;
            var newHeight = 100;
            var marginLeft = 0;
            var marginTop = 0;

            if (imageWidth > imageHeight) {
                newWidth = Math.round((imageWidth / imageHeight) * 100);
                marginLeft = Math.round((newWidth - 100) / 2);
            } else {
                newHeight = Math.round((imageHeight / imageWidth) * 100);
                marginTop = Math.round((newHeight - 100) / 2);
            }

            $preview.css({
                width: newWidth + 'px',
                height: newHeight + 'px',
                marginLeft: '-' + marginLeft + 'px',
                marginTop: '-' + marginTop + 'px'
            }).show();
        };

        $(document).on('Modal::close', function(event, modal) {
            if (modal.prop('id') != modalId) {
                return;
            }

            jcropApi.destroy();
            $modalImage.empty();
        });
    });
});